import { useEffect, useRef } from 'react';

const ATTRIBUTES = {
  inert: true,
  tabIndex: -1
} as const;

const STYLES = {
  display: 'block',
  width: 'auto',
  visibility: 'hidden',
  position: 'absolute',
  top: '-9999px',
  left: '-9999px',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  userSelect: 'none'
};

export const useMeasurer = () => {
  const parentRef = useRef<HTMLDivElement | null>(null);
  const measurerRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (!parentRef.current) {
      return;
    }

    const measurer = Object.assign(document.createElement('span'), ATTRIBUTES);
    Object.assign(measurer.style, STYLES);
    parentRef.current.appendChild(measurer);
    measurerRef.current = measurer;

    return () => {
      measurerRef.current?.remove();
      measurerRef.current = null;
    };
  }, []);

  return { measurerRef, parentRef };
};
